$(document).on('resize', function() {
  navitagionOnScroll();
});

$(document).on('scroll', function() {
  navitagionOnScroll();
});

/* Lleva cualquier #hash de la url a un ID existente en la pagina con una trasicion suave */
function anchorGoToHash() {
  $('a[href*="#"]:not([href="#"])').click(function (e) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
        return false;
      }
    }
  });
}

/* nav styles and actions */
function navitagionOnScroll() {
  if ($('.l-hero').length > 0) {
    var st = $(window).scrollTop();
    var ot = $('.l-hero').offset().top + 200;

    /* set multiple styles to nav */
    if (st > ot) {
      $('.c-navigation').addClass('is-dark');
      $('.c-navigation').removeClass('is-transparent');
    } else {
      $('.c-navigation__trigger img').attr('src', 'assets/img/misc/c-navigation__menu_white.svg');
      $('.c-navigation').removeClass('is-dark');
      $('.c-navigation').addClass('is-transparent');
    }
  }
}

/* nav behavior on trigger */
function triggerMenuNavigation() {
  $('.c-navigation__trigger').on('click', function() {
    var bars = $(this).find('.c-navigation__bars');

    if (bars.hasClass('is-opened')) {
      bars.removeClass('is-opened');
      $('.c-navigation__menu').hide();
      $(this).removeClass('is-visible');
      if ( $('.c-navigation').hasClass('is-transparent') ) {
        $('.c-navigation').removeClass('is-dark');
      }
    } else {
      bars.addClass('is-opened');
      $('.c-navigation__menu').show();
      $(this).addClass('is-visible');
    }
  });
}

function prefentDefaultFunction(event) {
  event.preventDefault();
}

function enableInputs() {
  $('table input').removeAttr('disabled');
  $('.c-save__datepicker, .c-save__edit').css('display', 'none');
  $('.c-save__button, .c-save__cancel').css('display', 'inline-block');
}

function disableInputs() {
  $('table input').attr('disabled', 'true');
  $('.c-save__datepicker, .c-save__edit').css('display', 'inline-block');
  $('.c-save__button, .c-save__cancel').css('display', 'none');

}

function openModal(){
  $('.c-modal__trigger').on('click', function(){
    var modal = $(this).data('modal');

    $('#' + modal).addClass('is-open');
  })

  $('.c-modal__close').on('click', function(){
    $('.c-modal__overlay').removeClass('is-open');
  })
}
